import {Component} from '@angular/core';
import '../../assets/css/styles.css';

import {AuthenticationService} from "../services/authentication.service";
import {Role} from "../services/dtos/enums/role.enum";
import {SelectLibraryModal} from "./modals/select-library/select-library.modal.component";
import {UserSessionService} from "../services/user-session.service";

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [ require('./app.component.css') ]
})
export class AppComponent {

    isNavCollapsed: boolean = true;

    constructor(
        public userSession: UserSessionService,
        public authenticationService: AuthenticationService,
        private selectLibraryModal: SelectLibraryModal
    ) {
    }

    showAdminMenu(): boolean {
        return this.canAccessUserManagement() || this.canAccessLicenceManagement();
    }

    canAccessUserManagement(): boolean {
        return this.authenticationService.isInLibraryRole(this.userSession.libraryId, Role.UserManagement) ||
            this.authenticationService.isInGlobalRole(Role.UserManagement);
    }

    canAccessLicenceManagement(): boolean {
        return this.authenticationService.isInGlobalRole(Role.UserManagement);
    }

    selectLibrary(): void {
        this.selectLibraryModal.open();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/app.component.ts